export default __webpack_public_path__ + "static/media/glover.98225328.jpg";